import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { apiAction, generalSet } from '../../store/generalSlice';
import { checkChangeBudgetActionData, parseJSON } from '../../utils/helpers';
import Spinner from '../../layout/Spinner';

const EditChangeBidAmount = () => {
  const dispatch = useDispatch();
  const { action_id } = useParams();
  const { action, updatingAction } = useSelector((state) => state.general);
  const [formStateActionData, setFormStateActionData] = useState({});
  const [error, setError] = useState({});

  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'action',
        route: `actions/getactionById`,
        actionId: action_id,
      }),
    );
  }, [dispatch, action_id]);

  const checkState = action?._id && action?.actionData ? true : false;

  useEffect(() => {
    if (checkState) {
      setFormStateActionData(parseJSON(action.actionData));
    }
  }, [checkState, action]);
  console.log({ action, checkState, formStateActionData });
  return checkState ? (
    <div className='container mt-4' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center border-bottom'>
        <h1>
          Edit Action: <span className='text-primary'>{formStateActionData?.name}</span>
        </h1>
      </div>
      <div className='row d-flex justify-content-center mt-4'>
        <div className='col-md-12 d-flex justify-content-center'>Change Name</div>
        <div className='col-md-6'>
          <input
            type='text'
            className='form-control'
            placeholder='Action name...'
            style={{ textAlign: 'center' }}
            value={formStateActionData?.name}
            onChange={(e) => setFormStateActionData({ ...formStateActionData, name: e.target.value })}
          />
        </div>
      </div>
      <div className='row d-flex justify-content-center mt-4'>
        <input
          className='mr-1'
          type='checkbox'
          checked={formStateActionData.useFixedBudget}
          onChange={(e) => setFormStateActionData({ ...formStateActionData, useFixedBudget: e.target.checked })}
        />{' '}
        Use Fixed Budget
      </div>
      {formStateActionData?.useFixedBudget ? (
        <>
          <div className='row d-flex justify-content-center mt-4'>
            <div className='col-md-2 d-flex justify-content-center'>
              <input
                type='number'
                placeholder='Fixed Budget'
                className='form-control'
                style={{ textAlign: 'center' }}
                defaultValue={formStateActionData.fixedValue}
                onChange={(e) => setFormStateActionData({ ...formStateActionData, fixedValue: e.target.value })}
              />{' '}
            </div>
          </div>
        </>
      ) : (
        <>
          <div className='row d-flex justify-content-center mt-4'>
            <button
              className={`btn btn${formStateActionData.unit === 'percentage' ? '' : '-outline'}-primary`}
              disabled={updatingAction}
              onClick={() => {
                setFormStateActionData({ ...formStateActionData, unit: 'percentage' });
              }}
            >
              Percentage
            </button>
            <button
              className={`ml-2 btn btn${formStateActionData.unit === 'amount' ? '' : '-outline'}-primary`}
              disabled={updatingAction}
              onClick={() => {
                setFormStateActionData({ ...formStateActionData, unit: 'amount' });
              }}
            >
              Amount
            </button>
            <button
              className={`ml-2 btn btn${formStateActionData.unit === 'spend_column' ? '' : '-outline'}-primary`}
              disabled={updatingAction}
              onClick={() => {
                setFormStateActionData({ ...formStateActionData, unit: 'spend_column' });
              }}
            >
              Spend Column
            </button>
          </div>
          <div className='row d-flex justify-content-center mt-2'>
            <div className='col-md-2 d-flex justify-content-center'>
              <input
                type='number'
                className='form-control'
                style={{ textAlign: 'center' }}
                placeholder='Value'
                defaultValue={formStateActionData.value}
                onChange={(e) => setFormStateActionData({ ...formStateActionData, value: e.target.value })}
              />
            </div>
          </div>
          <div className='row d-flex justify-content-center mt-4'>
            <div className='col-md-12 d-flex justify-content-center'>
              <div className='btn-group'>
                <input
                  type='checkbox'
                  checked={formStateActionData.useMaxBudget}
                  className='mr-2'
                  style={{ textAlign: 'center' }}
                  onChange={(e) => setFormStateActionData({ ...formStateActionData, useMaxBudget: e.target.checked })}
                />
                <span>Use Max Budget</span>
              </div>
            </div>
            {formStateActionData.useMaxBudget ? (
              <>
                <div className='col-md-2 d-flex justify-content-center mt-1'>
                  <input
                    type='number'
                    className='form-control'
                    placeholder='Value'
                    defaultValue={formStateActionData.maxBudget}
                    style={{ textAlign: 'center' }}
                    onChange={(e) => setFormStateActionData({ ...formStateActionData, maxBudget: e.target.value || 0 })}
                  />
                </div>
              </>
            ) : null}
          </div>
          <div className='row d-flex justify-content-center mt-4'>
            <div className='col-md-12 d-flex justify-content-center'>
              <div className='btn-group'>
                <input
                  type='checkbox'
                  checked={formStateActionData.useMinBudget}
                  className='mr-2'
                  style={{ textAlign: 'center' }}
                  onChange={(e) => setFormStateActionData({ ...formStateActionData, useMinBudget: e.target.checked })}
                />
                <span>Use Min Budget</span>
              </div>
            </div>
            {formStateActionData.useMinBudget ? (
              <>
                <div className='col-md-2 d-flex justify-content-center mt-1'>
                  <input
                    type='number'
                    className='form-control'
                    placeholder='Value'
                    defaultValue={formStateActionData.minBudget}
                    style={{ textAlign: 'center' }}
                    onChange={(e) => setFormStateActionData({ ...formStateActionData, minBudget: e.target.value || 0 })}
                  />
                </div>
              </>
            ) : null}
          </div>
        </>
      )}

      <div className='row d-flex justify-content-center mt-4'>
        <button
          className='btn btn-success'
          disabled={updatingAction}
          onClick={() => {
            const checkResult = checkChangeBudgetActionData(formStateActionData);
            if (checkResult.error) {
              setError({ msg: checkResult.msg });
              return;
            }
            if (checkResult.success) {
              setError({});
              dispatch(generalSet({ reduxField: 'updatingAction', value: true }));
              dispatch(
                apiAction({
                  reduxField: 'action',
                  route: `actions/updateActionById`,
                  actionId: action_id,
                  actionData: formStateActionData,
                  setLoading: 'updatingAction',
                }),
              );
            }
          }}
        >
          {updatingAction ? <Spinner width={'33px'} /> : 'Save'}
        </button>
      </div>

      {error.msg ? (
        <div className='row d-flex justify-content-center mt-4' data-aos='fade-up' data-aos-delay='200'>
          <div className='alert alert-danger' role='alert'>
            {error.msg}
          </div>
        </div>
      ) : null}
    </div>
  ) : (
    <Spinner />
  );
};

export default EditChangeBidAmount;
